window.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-contact-form]');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const subject = form.querySelector('[data-contact-subject], [name="contact[subject]"]');
  const message = form.querySelector('[name="contact[body]"]');

  const source = params.get('source');
  const title = params.get('title');
  const product = params.get('product');
  const variant = params.get('variant');
  const variantTitle = params.get('variant_title');

  if (subject && !subject.value) {
    if (source === 'product' && title) {
      subject.value = `Enquiry: ${title}`;
    } else if (source === 'custom-made') {
      subject.value = 'Custom made enquiry';
    }
  }

  if (message && !message.value) {
    const lines = [];

    if (source === 'product') {
      lines.push('Hello, I would like to enquire about this product.');
      if (title) lines.push(`Product: ${title}`);
      if (product) lines.push(`Handle: ${product}`);
      if (variant) lines.push(`Variant ID: ${variant}`);
      if (variantTitle) lines.push(`Variant: ${variantTitle}`);
    }

    if (source === 'custom-made') {
      lines.push('Hello, I would like to discuss a custom made piece.');
    }

    if (lines.length) {
      message.value = `${lines.join('\n')}\n\n`;
    }
  }
});
